module.exports = __webpack_public_path__ + "static/media/Avatars_Other_New-06.b554dc1c.jpg";